var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-form" },
    [
      _c(
        "a-steps",
        {
          style: _vm.stepStyle,
          attrs: { type: "navigation", size: "small" },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        [
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.selectContactFile"),
              description: _vm.$t("wp.selectContactCsvOrExcel"),
              status: _vm.current === 0 ? "process" : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: _vm.$t("wp.importConfiguration"),
              description: _vm.$t("wp.customizeFile"),
              status: _vm.current === 1 ? "process" : "wait",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.current === 0
        ? _c("div", { staticClass: "fileSelection" }, [
            _c(
              "div",
              { staticClass: "file-box", on: { click: _vm.openSelectFile } },
              [
                _c(
                  "div",
                  {},
                  [
                    _c("a-icon", {
                      staticStyle: { "font-size": "50px", color: "#08c" },
                      attrs: { type: "file-excel" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "file-details" }, [
                  _vm.file
                    ? _c("span", [_vm._v(_vm._s(_vm.file.name))])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.selectFile")))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("wp.csvOrExcelFile")))]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.current === 1
        ? _c("div", { staticClass: "configuration" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("section", { staticClass: "general" }, [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", [_vm._v(" First Row Contains Header ? ")]),
                      _vm._v(" "),
                      _c("a-switch", {
                        model: {
                          value: _vm.firstRowContainsHeader,
                          callback: function ($$v) {
                            _vm.firstRowContainsHeader = $$v
                          },
                          expression: "firstRowContainsHeader",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.excelMode
                    ? _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", [_vm._v(" Seperator Character ")]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              model: {
                                value: _vm.seperator,
                                callback: function ($$v) {
                                  _vm.seperator = $$v
                                },
                                expression: "seperator",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "," } }, [
                                _vm._v("Comma (,)"),
                              ]),
                              _vm._v(" "),
                              _c("a-select-option", { attrs: { value: ";" } }, [
                                _vm._v("Semicolon (;)"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("a-divider"),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "fields" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(Object.keys(_vm.mapping), function (field) {
                      return _c(
                        "div",
                        { key: field, staticClass: "field-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c("a-select", {
                                attrs: {
                                  options: _vm.getSelectOptionsForFields(),
                                  value: field,
                                  disabled: true,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field" },
                            [
                              _c("a-select", {
                                attrs: {
                                  value: _vm.mapping[field],
                                  options: _vm.getSelectOptionsForColumns(),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.changeFieldValue(field, value)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c(
                "section",
                { staticClass: "result" },
                [
                  _c("label", [_vm._v("Example Result Preview")]),
                  _vm._v(" "),
                  _c("ve-table", {
                    attrs: {
                      columns: _vm.getTableDataSource().columns,
                      "table-data": _vm.getTableDataSource().rows,
                      "row-style-option": _vm.rowStyleOption,
                      "border-x": true,
                      "border-y": true,
                      "row-key-field-name": "phone",
                      id: "audit-logs-table",
                      "fixed-header": true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "footer" },
                [
                  _c("a-button", { on: { click: _vm.onCancelled } }, [
                    _vm._v("Cancel"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.importing },
                      on: { click: _vm.save },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.importing ? "Importing" : "Import Contacts"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "headers" }, [
      _c("label", [_vm._v("SUPSIS FIELD")]),
      _vm._v(" "),
      _c("label"),
      _vm._v(" "),
      _c("label", [_vm._v("EXCEL/CSV COLUMN")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }